import Image from 'next/image';

import { fontStyles } from '@/styles/typography';

interface FeedbackTooltipProps {
  onDismiss: () => void;
}

export function FeedbackTooltip({ onDismiss }: FeedbackTooltipProps) {
  return (
    <div
      className="absolute top-[calc(100%+8px)] right-0 w-[208px] h-[198px] bg-special-background-tooltip rounded-sm shadow-25 p-3.5 z-50 flex flex-col"
      role="tooltip"
    >
      <div className="w-full h-[120px] rounded-[6px] mb-3 relative overflow-hidden shadow-05">
        <Image
          src="/images/user-feedback/give-feedback.webp"
          alt="Give feedback hint"
          fill
          style={{ objectFit: 'cover' }}
          className="block dark:hidden"
        />
        <Image
          src="/images/user-feedback/give-feedback-dark.webp"
          alt="Give feedback hint"
          fill
          style={{ objectFit: 'cover' }}
          className="hidden dark:block"
        />
      </div>

      <div className="flex flex-col gap-2 flex-1">
        <p
          className={fontStyles({
            variant: 'LABEL_SM',
            class: 'text-token-gray-1600 text-left',
          })}
        >
          Share feedback anytime from the ••• menu
        </p>

        <button
          onClick={onDismiss}
          className={fontStyles({
            variant: 'LABEL_SM',
            class: [
              'text-token-purple-900',
              'text-left',
              'cursor-pointer',
              'focus:outline-none',
              'hover:underline',
              'w-fit',
            ],
          })}
        >
          Got it
        </button>
      </div>
    </div>
  );
}
